import { Company } from '../services/company.service';

/** Where a network member stands: approved, waiting for the Zentrale, or not done yet. */
export type MemberStatus = 'active' | 'waiting' | 'incomplete' | 'ended';

export function memberStatus(company: Company): MemberStatus {
  if (company.group_membership_status === 'active') return 'active';
  if (company.group_membership_status !== 'pending') return 'ended';
  // The IBAN is a dashboard task: the network can approve a member without it.
  return company.is_profile_completed ? 'waiting' : 'incomplete';
}

export const MEMBER_STATUS_LABELS: Record<MemberStatus, string> = {
  active: 'Aktives Mitglied',
  waiting: 'Wartet auf Freigabe',
  incomplete: 'Registrierung unvollständig',
  ended: 'Kein aktives Mitglied',
};

/** "März 2026" - the month a member joined. */
export function memberSince(joinedAt: string): string {
  return new Date(joinedAt).toLocaleDateString('de-DE', { month: 'long', year: 'numeric' });
}
